module.exports = __webpack_public_path__ + "img/14-3.8bdda766.png";